import { useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-grid-system";
import Moment from "react-moment";
import Modal from "react-modal";
import { Button } from "../Button";
import { Date } from "../Date";
import EditIcon from "../../assets/img/icons/edit.svg";
import LinkIcon from "../../assets/img/icons/link-inactive.svg";
import { StyledField } from "../../styles/StyledField";
import { StyledUnitTitle } from "../../styles/StyledUnit";
import { useMeetingContext } from "../../context/meetingContext";
import ClockIcon from "../../assets/img/icons/clock.svg";
import DeleteIcon from "../../assets/img/icons/delete-green.svg";
import AgendaIcon from "../../assets/img/icons/agenda.svg";
import AgendaGreenIcon from "../../assets/img/icons/agenda-green.svg";
import MinutesIcon from "../../assets/img/icons/minutes.svg";
import MinutesGreenIcon from "../../assets/img/icons/minutes-green.svg";
import moment from "moment";
import { useState } from "react";
import { ConfirmationModal } from "../ConfirmationModal";
import { deleteMeeting, getMeetingPoints } from "../../api/meeting/meeting";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AgendaButton, AgendaButtonsContainer, AgendaPoint } from "../../styles/StyledMeeting";
import { useQuery } from "react-query";
import ModalHeader from "../ModalHeader/ModalHeader";
import QueryLoader from "../Loader/QueryLoader";
import { StyledModal } from "../../styles/StyledModal";

export default function MeetingHeader({ onClick }) {
	const axiosHandler = useAxiosPrivate();
	const { axiosPrivate } = useAxiosPrivate();
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const { id, title, place, startDate, organizationUnit, endDate, guestUsers, guestUnits } = useMeetingContext();

	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [minutesAdded, setMinutesAdded] = useState(false);

	const [agendaModalIsOpen, setAgendaModalIsOpen] = useState(searchParams.get("agenda") ? true : false);
	const [minutesModalIsOpen, setMinutesModalIsOpen] = useState(searchParams.get("minutes") ? true : false);

	const { isLoading, isError, error, data } = useQuery(["agenda", id], () => getMeetingPoints(axiosHandler.axiosPrivate, id));

	useEffect(() => {
		if (!isLoading) {
			let tempMinutesAdded = false;
			data.map((e) => {
				if (e?.minutes) tempMinutesAdded = true;
			});
			setMinutesAdded(tempMinutesAdded);
		}
	}, [isLoading]);

	useEffect(() => {
		if (isError) console.log(error);
		Modal.setAppElement("body");
	}, []);

	return (
		<>
			<Row>
				<Col sm={5}>
					<StyledUnitTitle>
						<div>
							<h1>{title || ""}</h1>
							<Row>
								<Col sm={6}>
									<Button onClick={onClick} bg={false} icon={EditIcon} small>
										Edit meeting
									</Button>
								</Col>
								<Col sm={6}>
									<Button onClick={() => setModalIsOpen(true)} bg={false} icon={DeleteIcon} small>
										Delete meeting
									</Button>
								</Col>
							</Row>
							<AgendaButtonsContainer>
								<AgendaButton
									onClick={() => {
										if (data && data?.length > 0) setAgendaModalIsOpen(true);
									}}
									active={data && data?.length > 0 ? true : false}
								>
									Agenda
									<img src={data && data?.length ? AgendaGreenIcon : AgendaIcon} alt="Agenda icon" />
								</AgendaButton>
								<AgendaButton
									onClick={() => {
										if (minutesAdded) setMinutesModalIsOpen(true);
									}}
									active={minutesAdded}
								>
									Minutes
									<img src={minutesAdded ? MinutesGreenIcon : MinutesIcon} alt="Minutes icon" />
								</AgendaButton>
							</AgendaButtonsContainer>
						</div>
					</StyledUnitTitle>
				</Col>
				<Col style={{ overflow: "hidden" }} sm={6} offset={{ sm: 1 }}>
					<Row>
						<Col sm={4} xl={3} xxxl={2}>
							<StyledField mb="12px">
								<label>Date</label>
								<Date>
									<Moment format="YYYY-MM-DD">{startDate}</Moment>
								</Date>
							</StyledField>
						</Col>
						<Col sm={4} xl={3} xxxl={2}>
							<StyledField mb="12px">
								<label>Time</label>
								<span>
									<img src={ClockIcon} alt="Clock icon" />
									{moment(startDate).format("HH:mm")}-{moment(endDate).format("HH:mm")}
								</span>
							</StyledField>
						</Col>
						<Col sm={4} xl={3} xxxl={2}>
							<StyledField mb="12px">
								<label>Unit</label>
								<span>{organizationUnit.name}</span>
							</StyledField>
						</Col>
					</Row>
					<Row>
						<Col>
							<StyledField mb="12px">
								<label>Place</label>
								<span>{place}</span>
							</StyledField>
						</Col>
					</Row>
				</Col>
			</Row>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => {
					setModalIsOpen(false);
				}}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ConfirmationModal
					handleDelete={(id) => deleteMeeting(axiosPrivate, id, () => navigate("/"))}
					deletedId={id}
					closeModal={() => {
						setModalIsOpen(false);
					}}
				/>
			</Modal>
			<Modal
				isOpen={agendaModalIsOpen}
				onRequestClose={() => {
					setAgendaModalIsOpen(false);
				}}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ModalHeader
					onClick={() => {
						setAgendaModalIsOpen(false);
					}}
				>
					<div>
						<label>Meeting title</label>
						<span>
							{title}
							<img
								onClick={() => navigator.clipboard.writeText(window.location.href + "?agenda=true")}
								src={LinkIcon}
								alt="Copy link icon"
							/>
						</span>
					</div>
				</ModalHeader>
				{!isLoading && data ? (
					<>
						<Row>
							<Col sm={3}>
								<StyledField mb="12px">
									<label>Date</label>
									<Date>
										<Moment format="YYYY-MM-DD">{startDate}</Moment>
									</Date>
								</StyledField>
							</Col>
							<Col sm={3}>
								<StyledField mb="12px">
									<label>Time</label>
									<span>
										<img src={ClockIcon} alt="Clock icon" />
										{moment(startDate).format("HH:mm")}-{moment(endDate).format("HH:mm")}
									</span>
								</StyledField>
							</Col>
							<Col sm={6}>
								<Col>
									<StyledField mb="12px">
										<label>Place</label>
										<span>{place}</span>
									</StyledField>
								</Col>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<StyledField mb="12px">
									<label>Organizer</label>
									<span>{organizationUnit.name}</span>
								</StyledField>
							</Col>
						</Row>
						<Row>
							<Col>
								<StyledField mb="12px">
									<label>Participants</label>
									<span>
										{guestUsers.map((e, i) => {
											return `${i > 0 ? ", " : " "}` + e.firstName + " " + e.lastName;
										})}
										{guestUsers.length > 0 && ", "}
										{guestUnits.map((e, i) => {
											return `${i > 0 ? ", " : " "}` + e.name;
										})}
									</span>
								</StyledField>
							</Col>
						</Row>
						<Row>
							<Col>
								<StyledField mb="12px">
									<label>Agenda</label>
									{data.map((e, i) => {
										return (
											<AgendaPoint key={i}>
												<h4>
													{i + 1}. {e.title}
												</h4>
												<p>{e.details}</p>
												{e?.decision && <h5>{e.decision.name}</h5>}
											</AgendaPoint>
										);
									})}
								</StyledField>
							</Col>
						</Row>
					</>
				) : (
					<QueryLoader />
				)}
			</Modal>
			<Modal
				isOpen={minutesModalIsOpen}
				onRequestClose={() => {
					setMinutesModalIsOpen(false);
				}}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ModalHeader
					onClick={() => {
						setMinutesModalIsOpen(false);
					}}
				>
					<div>
						<label>Meeting title</label>
						<span>
							{title}
							<img
								onClick={() => navigator.clipboard.writeText(window.location.href + "?minutes=true")}
								src={LinkIcon}
								alt="Copy link icon"
							/>
						</span>
					</div>
				</ModalHeader>
				{!isLoading && data ? (
					<>
						<Row>
							<Col sm={3}>
								<StyledField mb="12px">
									<label>Date</label>
									<Date>
										<Moment format="YYYY-MM-DD">{startDate}</Moment>
									</Date>
								</StyledField>
							</Col>
							<Col sm={3}>
								<StyledField mb="12px">
									<label>Time</label>
									<span>
										<img src={ClockIcon} alt="Clock icon" />
										{moment(startDate).format("HH:mm")}-{moment(endDate).format("HH:mm")}
									</span>
								</StyledField>
							</Col>
							<Col sm={6}>
								<Col>
									<StyledField mb="12px">
										<label>Place</label>
										<span>{place}</span>
									</StyledField>
								</Col>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<StyledField mb="12px">
									<label>Organizer</label>
									<span>{organizationUnit.name}</span>
								</StyledField>
							</Col>
						</Row>
						<Row>
							<Col>
								<StyledField mb="12px">
									<label>Participants</label>
									<span>
										{guestUsers.map((e, i) => {
											return `${i > 0 ? ", " : " "}` + e.firstName + " " + e.lastName;
										})}
										{guestUsers.length > 0 && ", "}
										{guestUnits.map((e, i) => {
											return `${i > 0 ? ", " : " "}` + e.name;
										})}
									</span>
								</StyledField>
							</Col>
						</Row>
						<Row>
							<Col>
								<StyledField mb="12px">
									<label>Agenda point</label>
									{data.map((e, i) => {
										return (
											<AgendaPoint key={i}>
												<h4>
													{i + 1}. {e.title}
												</h4>
												<p>
													{e.details} {e?.minutes && e.minutes}
												</p>
												{e?.decision && <h5>{e.decision.name}</h5>}
											</AgendaPoint>
										);
									})}
								</StyledField>
							</Col>
						</Row>
					</>
				) : (
					<QueryLoader />
				)}
			</Modal>
		</>
	);
}

MeetingHeader.propTypes = {
	data: PropTypes.object,
	onClick: PropTypes.func,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
